"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFutureChilds = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var crumbs_1 = require("../crumbs");
var qihuotable_1 = require("../qihuotable");
var delaytips_1 = require("./shared/delaytips");
/**
 * 期货-子品种
 */
function PageFutureChilds() {
    var location = (0, react_router_dom_1.useLocation)();
    var hash_sharp = location.hash;
    return (react_1.default.createElement("div", { className: "futures" },
        //显示延迟tip提示 中金所
        hash_sharp.indexOf('#futures_cffex') == 0 || hash_sharp.indexOf('#futures_220') == 0 ? react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, { insertRight: (0, delaytips_1.DelayMin15Tip)(), hideFresh: true })
            :
                react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(qihuotable_1.QiHuoTable, null)));
}
exports.PageFutureChilds = PageFutureChilds;
